import React from 'react';
import {
    DateRow,
    DisplayIdRow,
    LinkRow,
    PriceRow,
    TextRow,
    TypeRow,
    BatchFlagRow,
    MinLoader,
    ApptDetailRow,
    SimpleTooltip,
    FixDecimalToTree,
} from 'components';
import { makeCapitalize, PermissionList, RolePermission, Images, Colors } from 'utils';
import { Checkbox } from '@mui/material';

export const ACTION_TYPE = 'GET_ACTIVE_PAYROLL';
const label = { inputProps: { 'aria-label': 'Color switch demo' } };

/**
 * Pay types offered by the Active tab's Type column filter.
 *
 * Exported rather than inlined in the head so the SelectedFilters chip bar can label a selection
 * from the same list the column offered it from. The column prepends its own `All` option; that is
 * a control, not a value, so it stays out of here.
 */
export const payrollTypeFilterList = [
    { name: 'Hourly', id: 'HOURLY' },
    { name: 'Salary', id: 'SALARY' },
    { name: 'Fixed', id: 'FIXED' },
    { name: 'Mileage', id: 'MILEAGE' },
];

export const activePayrollHead = (handleSelect, fullList, selected, selectAllList) => {
    return [
        RolePermission([PermissionList.PAYROLL_MANAGE?.code]) &&
        {
            renderView: (
                <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                    <Checkbox
                        {...label}
                        onClick={(e) => handleSelect(e, '', 'all')}
                        name={'checkBox'}
                        style={{ padding: 0, color: '#347AF0' }}
                        checked={selectAllList ? true : fullList?.length === selected?.length}
                    />
                </SimpleTooltip>
            ),
            width: '50px',
        },
        { name: '', title: 'Timesheet ID', custom: false, noSearch: true },
        { name: 'timesheetDate', title: 'Date', iconType: 'date', noSearch: true },
        { name: '', title: 'Appt ID', custom: false, noSearch: true },
        { name: '', title: 'CPT Code', custom: false, noSearch: true },
        { name: '', title: 'Staff name', custom: false, noSearch: true },
        {
            name: 'type',
            title: 'Type',
            disabled: true,
            filterList: [{ name: 'All', id: 'All' }, ...payrollTypeFilterList],
            noSearch: true,
        },
        { name: '', title: 'Paycode', custom: false, noSearch: true },
        { name: '', title: 'Rate', custom: false, noSearch: true },
        { name: '', title: 'Qty', custom: false, noSearch: true },
        { name: '', title: 'Total AMT', custom: false, noSearch: true },
    ];
};

export const activePayrollBody = (afterSuccess, handleSelect, selected, selectAllList) => {
    return [
        RolePermission([PermissionList.PAYROLL_MANAGE?.code]) && {
            button: (handle, item) => (
                <Checkbox
                    {...label}
                    onClick={(e) => handleSelect(e, item)}
                    name={'checkBox'}
                    style={{ padding: 0, color: '#347AF0' }}
                    checked={selectAllList ? true : selected?.includes(item?.id)}
                />
            ),
            notClickable: true,
        },


        { rowText: (item) => <DisplayIdRow id={item?.displayId} /> },
        { rowText: (item) => <DateRow date={item?.timesheetDate} /> },
        {
            rowText: (item) =>
                item?.apptDisplayId ? (
                    <ApptDetailRow name={item?.apptDisplayId ? item.apptDisplayId : '--'} id={item?.apptId} afterSuccess={afterSuccess} />
                ) : (
                    '--'
                ),
            notClickable: true,
        },
        { rowText: (item) => <TextRow name={item?.cptCode ? item?.cptCode : '--'} /> },
        {
            rowText: (item) => (
                <LinkRow
                    name={item?.staffName ? item.staffName : '--'}
                    href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.staffId}` : ''}
                    checkPermission={item?.staffId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                    textWidth={8}
                />
            ),
            notClickable: true,
        },

        { rowText: (item) => <TypeRow text={item?.type ? item?.type : '--'} /> },
        { rowText: (item) => <TextRow name={item?.payCode ? item?.payCode : '--'} /> },
        { rowText: (item) => <PriceRow info={item?.amount} /> },
        { rowText: (item) => <FixDecimalToTree number={item?.qty} /> },
        { rowText: (item) => <PriceRow info={item?.totalAmount} /> },
    ];
};

// export const informationHead = [
//     { name: 'rateType', title: 'Rate Type', custom: false, noSearch: true },
//     { name: 'rate', title: 'Rate', custom: false, noSearch: true },
//     { name: 'hours', title: 'Hours', custom: false, noSearch: true },
//     { name: 'amount', title: 'Amount', custom: false, noSearch: true },
// ];
//
// export const informationBody = [
//     {
//         rowText: (item) => <TextRow
//             name={item?.payCode?.payCodeTypeId?.type ? makeCapitalize(item?.payCode?.payCodeTypeId?.type) : 'Fixed'}
//             textWidth={10} />,
//     },
//     {
//         rowText: (item) => <PriceRow
//             info={!!item?.amount && !!item?.hours ? item.amount / item.hours : item?.payCode?.rate} textWidth={10} />,
//     },
//     {
//         rowText: (item) => <TextRow name={item?.regularHours === 'NaNhNaNm' ? '--' : item?.regularHours || item?.hours}
//                                     textWidth={10} />,
//     },
//     { rowText: (item) => <PriceRow info={item.totalAmount ? item?.totalAmount : 0} textWidth={10} /> },
// ];
//

// export const PROCESSED_ACTION_TYPE = 'GET_PROCESSED_PAYROLL';
//
//
// export const processedHead = [
//     { name: '', title: 'Batch ID', custom: false, width: '15%' },
//     { name: '', title: 'Processor', custom: false, width: '15%' },
//     { name: '', title: 'Start Date', custom: false, width: '13%' },
//     { name: '', title: 'End Date', custom: false, width: '13%' },
//     { name: '', title: 'Processed Date', custom: false, width: '15%' },
//     { name: '', title: 'Total Pay', custom: false, width: '10%' },
//     { name: '', title: 'Batch CSV', custom: false, width: '15%' },
// ];
//
// export const processedBody = (i, handleDownload, currentId, loadDownload) => [
//     { value: <BatchFlagRow flag={i?.flag} id={i?.displayId} notShowResolve={true} />, width: '15%' },
//     {
//         value: <LinkRow
//             name={i?.processorName ? i?.processorName : '--'}
//             href={
//                 RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${i?.processorId}` : ''
//             }
//             checkPermission={i?.processorId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
//         />, width: '15%',
//     },
//     { value: <DateRow date={i?.startDate} />, width: '13%' },
//     { value: <DateRow date={i?.endDate} />, width: '13%' },
//     { value: <DateRow date={i?.processedDate} />, width: '15%' },
//     { value: <PriceRow info={i?.totalPay} textWidth={10} />, width: '10%' },
//     {
//         value: <div className="action-btn">
//             <button className="download-1500" style={{ height: 24 }} onClick={(e) => handleDownload(e, i?.id)}>
//                 <p>Download</p>
//                 {currentId === i?.id && loadDownload ?
//                     <MinLoader margin={'0'} color={Colors.ThemeBlue} position={'relative'} />
//                     :
//                     <img src={Images.download} alt="" />
//                 }
//             </button>
//         </div>, width: '15%',
//     },
// ];
//
//
// export const processorDetailBody = (item, handleOpenResolve, afterSuccess) => [
//     {
//         value: <BatchFlagRow
//             handleResolve={(e) => handleOpenResolve(e, item)}
//             resolve={item?.resolve}
//             notShowFlag={true}
//             flag={item?.flag}
//             id={item?.displayId}
//         />, width: '15%',
//     },
//     {
//         value: <DateRow date={item?.timesheetDate} />, width: '10%',
//     },
//     {
//         value: item?.apptDisplayId ?
//             <ApptDetailRow name={item?.apptDisplayId ? item.apptDisplayId : '--'} id={item?.apptId} showWidth={'100%'}
//                            afterSuccess={afterSuccess} /> : '--',
//         width: '10%', notClickable: true,
//     },
//     {
//         value: <LinkRow
//             name={item?.staffName ? item.staffName : '--'}
//             href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${item?.staffId}` : ''}
//             checkPermission={item?.staffId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
//             textWidth={8}
//         />, width: '10%', notClickable: true,
//     },
//     { value: <TypeRow text={item?.type} />, width: '10%' },
//     { value: <TextRow name={item?.payCode ? item.payCode : '--'} />, width: '10%' },
//     { value: <TextRow name={item?.cptCode ? item?.cptCode : '--'} />, width: '10%' },
//     { value: <PriceRow info={item?.amount} />, width: '10%' },
//     { value: <TextRow name={item?.qty ? item?.qty : '--'} />, width: '5%' },
//     { value: <PriceRow info={item?.totalAmount} />, width: '10%' },
// ];
//
// export const processorDetailHeight = [
//     { title: 'Timesheet ID', width: '15%' },
//     { title: 'Date', width: '10%' },
//     { title: 'Appt ID', width: '10%' },
//     { title: 'Staff Name', width: '10%' },
//     { title: 'Type', width: '10%' },
//     { title: 'Paycode', width: '10%' },
//     { title: 'CPT Code', width: '10%' },
//     { title: 'Rate', width: '10%' },
//     { title: 'Qty', width: '5%' },
//     { title: 'Total AMT', width: '10%' },
// ];
//

export const PAYROLL_ENUMS = {
    PROCESSED: 'PROCESSED',
    ACTIVE: 'ACTIVE',
};

export const activePayrollNotYet = {
    title: 'No active timesheets available',
    subTitle: 'It looks like there are currently no active timesheets. Once timesheets are created, they will appear here.',
    image: Images.noCalendar,
};

export const processedPayrollNotYet = {
    title: 'No processed timesheets available',
    subTitle: 'It looks like there are currently no active processed.',
    image: Images.noCalendar,
};

export const payrollTableInfo = (download, currentId, loadDownload, handleOpenResolve, afterSuccess, handleSelect, fullList, selected) => {
    return {
        loadingType: 'GET_PROCESSED_PAYROLL',

        head: [
            RolePermission([PermissionList.PAYROLL_MANAGE?.code]) && {
                renderView: (
                    <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                        <Checkbox
                            {...label}
                            onClick={(e) => handleSelect(e, '', 'all')}
                            name={'checkBox'}
                            style={{ padding: 0, color: '#347AF0' }}
                            checked={fullList?.length === selected?.length}
                        />
                    </SimpleTooltip>
                ),
                width: '35px',
            },
            { name: '', title: 'Batch ID', custom: false, noSearch: true, width: '15%' },
            { name: '', title: 'Processor', custom: false, noSearch: true, width: '15%' },
            { name: '', title: 'Start Date', custom: false, noSearch: true, width: '13%' },
            { name: '', title: 'End Date', custom: false, noSearch: true, width: '13%' },
            { name: '', title: 'Processed Date', custom: false, noSearch: true, width: '15%' },
            { name: '', title: 'Total Pay', custom: false, noSearch: true, width: '10%' },
            { name: '', title: 'Batch CSV', custom: false, noSearch: true, width: '13%' },
        ].filter(Boolean),

        body: (i) => {
            return [
                RolePermission([PermissionList.PAYROLL_MANAGE?.code]) && {
                    value: (
                        <Checkbox
                            {...label}
                            onClick={(e) => handleSelect(e, i)}
                            name={'checkBox'}
                            style={{ padding: 0, color: '#347AF0', marginLeft: '-3px', marginRight: '-1px' }}
                            checked={selected?.includes(i?.id)}
                        />
                    ),
                    notClickable: true,
                    width: '35px',
                },
                { value: <BatchFlagRow flag={i?.flag} id={i?.displayId} notShowResolve={true} />, width: '15%' },
                {
                    value: (
                        <LinkRow
                            name={i?.processorName ? i?.processorName : '--'}
                            href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${i?.processorId}` : ''}
                            checkPermission={i?.processorId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                        />
                    ),
                    width: '15%',
                },
                { value: <DateRow date={i?.startDate} />, width: '13%' },
                { value: <DateRow date={i?.endDate} />, width: '13%' },
                { value: <DateRow date={i?.processedDate} />, width: '15%' },
                { value: <PriceRow info={i?.totalPay} textWidth={10} />, width: '10%' },
                {
                    value: (
                        <div className="action-btn">
                            <button className="download-1500" style={{ height: 24 }} onClick={(e) => download(e, i?.id)}>
                                <p>Download</p>
                                {currentId === i?.id && loadDownload ? (
                                    <MinLoader margin={'0 0 0 3px'} color={Colors.ThemeBlue} position={'relative'} />
                                ) : (
                                    <img src={Images.download} alt="download" />
                                )}
                            </button>
                        </div>
                    ),
                    width: '13%',
                },
            ].filter(Boolean);
        },

        renderAccordionRow: (i) => i?.timesheets,

        accordionHead: [
            { title: 'Timesheet ID', width: '15%' },
            { title: 'Date', width: '10%' },
            { title: 'Appt ID', width: '10%' },
            { title: 'Staff Name', width: '10%' },
            { title: 'Type', width: '10%' },
            { title: 'Paycode', width: '10%' },
            { title: 'CPT Code', width: '10%' },
            { title: 'Rate', width: '10%' },
            { title: 'Qty', width: '5%' },
            { title: 'Total AMT', width: '10%' },
        ],

        accordionBody: (i) => [
            {
                value: (
                    <BatchFlagRow
                        handleResolve={(e) => handleOpenResolve(e, i)}
                        resolve={i?.resolve}
                        notShowFlag={true}
                        flag={i?.flag}
                        id={i?.displayId}
                    />
                ),
                width: '15%',
            },
            {
                value: <DateRow date={i?.timesheetDate} />,
                width: '10%',
            },
            {
                value: i?.apptDisplayId ? (
                    <ApptDetailRow
                        name={i?.apptDisplayId ? i.apptDisplayId : '--'}
                        id={i?.apptId}
                        showWidth={'100%'}
                        afterSuccess={afterSuccess}
                    />
                ) : (
                    '--'
                ),
                width: '10%',
                notClickable: true,
            },
            {
                value: (
                    <LinkRow
                        name={i?.staffName ? i.staffName : '--'}
                        href={RolePermission([PermissionList.STAFF_READ.code]) ? `/staff/${i?.staffId}` : ''}
                        checkPermission={i?.staffId ? RolePermission([PermissionList.STAFF_READ.code]) : null}
                        textWidth={8}
                    />
                ),
                width: '10%',
                notClickable: true,
            },
            { value: <TypeRow text={i?.type} />, width: '10%' },
            { value: <TextRow name={i?.payCode ? i.payCode : '--'} />, width: '10%' },
            { value: <TextRow name={i?.cptCode ? i?.cptCode : '--'} />, width: '10%' },
            { value: <PriceRow info={i?.amount} />, width: '10%' },
            { value: <TextRow name={i?.qty ? i?.qty.toFixed(2) : '--'} />, width: '5%' },
            { value: <PriceRow info={i?.totalAmount} />, width: '10%' },
        ],

        noDetailsText: 'No payrolls yet',
        notYet: {
            title: 'No processed timesheets available',
            subTitle: 'It looks like there are currently no active processed.',
            image: Images.noCalendar,
        },
    };
};

export const timeSheetTabEnums = {
    ACTIVE: 'ACTIVE',
    PROCESSED: 'PROCESSED',
};
export const timeSheetTabTypes = [
    { title: 'Active', tabValue: timeSheetTabEnums.ACTIVE },
    { title: 'Processed', tabValue: timeSheetTabEnums.PROCESSED },
];
